import React from 'react';
import { Shield, Award, Users, CheckCircle, Star } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const TrustIndicators = () => {
  const trustBadges = [
    {
      icon: Shield,
      title: 'GDPR Compliant',
      description: 'Full compliance with EU data protection regulations'
    },
    {
      icon: Award,
      title: 'Industry Recognition',
      description: 'Award-winning data strategy consultancy'
    },
    {
      icon: Users,
      title: '500+ Clients',
      description: 'Trusted by organizations across Europe'
    }
  ];

  const guarantees = [
    {
      icon: CheckCircle,
      text: '24-hour response guarantee'
    },
    {
      icon: CheckCircle,
      text: 'Free initial consultation'
    },
    {
      icon: CheckCircle,
      text: 'No-obligation assessment'
    },
    {
      icon: CheckCircle,
      text: 'Transparent pricing'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Trust Badges */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Organizations Trust Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Industry-leading security, compliance, and service excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {trustBadges?.map((badge, index) => {
            const Icon = badge?.icon;
            return (
              <div 
                key={index} 
                className="text-center p-6 rounded-lg border-2 border-gray-200 hover:border-blue-500 transition-colors duration-300"
              >
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {badge?.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {badge?.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Service Guarantees */}
        <div className="bg-blue-50 rounded-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Our Service Guarantees
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {guarantees?.map((guarantee, index) => {
              const Icon = guarantee?.icon;
              return (
                <div key={index} className="flex items-center space-x-3">
                  <Icon className="w-6 h-6 text-green-600 flex-shrink-0" />
                  <span className="text-gray-800 font-medium">
                    {guarantee?.text}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Client Satisfaction */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 bg-yellow-50 px-6 py-3 rounded-full">
            <div className="flex">
              {[1, 2, 3, 4, 5]?.map((star) => (
                <Star 
                  key={star} 
                  className="w-5 h-5 text-yellow-500 fill-current" 
                />
              ))}
            </div>
            <span className="text-gray-900 font-semibold">
              4.9/5.0 Client Satisfaction
            </span>
            <span className="text-gray-600">
              (Based on 200+ reviews)
            </span>
          </div>
        </div>

        {/* Security Notice */}
        <div className="mt-12 bg-gray-50 rounded-lg p-6 border-l-4 border-blue-600">
          <div className="flex items-start space-x-4">
            <Shield className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
            <div>
              <h4 className="text-lg font-semibold text-gray-900 mb-2">
                Your Data Security is Our Priority
              </h4>
              <p className="text-gray-600">
                All communications are encrypted and handled in accordance with GDPR standards.
                We never share your information with third parties without explicit consent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustIndicators;